import { Category, GQL_ID } from '@@types'
import { gql, useQuery } from '@apollo/client'

import { useAddressStore } from '@features/shipping-methods'

interface UseFetchCategoriesPreviewParams {
  shopId?: GQL_ID
  ids?: GQL_ID[]
  style?: string
  skip?: boolean
}

type CategoriesVariables = {
  shop_id: GQL_ID
  ids?: GQL_ID[]
  style?: string
}

type CategoriesQuery = {
  categories: Category[]
}

const GQL_CATEGORIES_PREVIEW = gql`
  query CategoriesPreview($shop_id: ID!, $ids: [ID], $style: String) {
    categories(shop_id: $shop_id, ids: $ids) {
      id
      name
      slug
      parent_id
      parent {
        id
        slug
      }
      icon(style: $style) {
        url
      }
      altIcon(style: $style) {
        url
      }
      is_alcohol
      preview_size
    }
  }
`

export function useFetchCategoriesPreview ({
  shopId,
  ids,
  style,
  skip = false
}: UseFetchCategoriesPreviewParams) {
  const { shopId: defaultShopId } = useAddressStore()
  
  const { data, loading, error, refetch } = useQuery<CategoriesQuery, CategoriesVariables>(GQL_CATEGORIES_PREVIEW, {
    variables: {
      shop_id: shopId || defaultShopId || '1',
      ids,
      style
    },
    skip,
    fetchPolicy: 'cache-and-network'
  })

  const categories = data?.categories?.filter(Boolean) ?? []

  return {
    categories,
    data,
    loading,
    error,
    refetch
  }
}